import { PwaController } from './pwa-controller';
export const admin = [PwaController];